module.exports = __webpack_public_path__ + "static/Gilroy-Thin-4be23ee9a451b9125aa83730a7fcff1b.woff";